import { useQuery } from "react-query";
import { MailingRecordService } from "../../../services/newsletter/mailingRecord.service";
export var useMailingRecordFilterOptions = function () {
    return useQuery('mailingRecordFilterOptions', MailingRecordService.getFilterOptions, {
        // 10 minutes
        staleTime: 10 * 60 * 1000
    });
};
